import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Come ricevo il materiale?',
  a: 'Immediatamente dopo il pagamento ricevi un link diretto per scaricare tutti i PDF. Puoi usarli già dalla prossima lezione.'
}, {
  q: 'È adattato per classi con diversi livelli?',
  a: 'Sì. Ogni volume include esercizi su 4 livelli: Base, Intermedio, Avanzato e Sfida.'
}, {
  q: 'I materiali sono stampabili?',
  a: 'Sì. Tutti i PDF sono ottimizzati per stampa, tablet, smartphone e LIM.'
}, {
  q: 'La valutazione è conforme alle linee guida MIUR?',
  a: 'Sì. Tutte le rubriche sono sviluppate in coerenza con le Indicazioni Nazionali e il framework DigComp 2.2.'
}, {
  q: 'Per quale classe è pensato il Kit?',
  a: "Copre l'intero ciclo secondario: dal Biennio al Triennio degli Istituti Tecnici, Professionali e Licei Scientifici."
}, {
  q: 'Posso utilizzarlo anche con studenti DSA o BES?',
  a: 'Sì. Include schede differenziate e mappe concettuali per studenti con bisogni educativi speciali.'
}, {
  q: 'Posso usare i contenuti per più anni scolastici?',
  a: 'Sì. Paghi una volta sola e i materiali sono tuoi per sempre, inclusi tutti gli aggiornamenti futuri.'
}, {
  q: 'Come funziona la garanzia di 14 giorni?',
  a: 'Scrivi una email a kitonline27@gmail.com e ricevi il rimborso completo in 24 ore. Senza domande.'
}, {
  q: 'Quali sono i metodi di pagamento accettati?',
  a: 'Carta di credito, carta di debito e PayPal. Pagamento sicuro e protetto.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 sm:py-14 px-4 bg-brand-dark" data-id="element-83">
      <div className="max-w-xl mx-auto" data-id="element-84">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-black text-center mb-8 text-brand-cream" data-id="element-85">
          Domande Frequenti
        </motion.h2>

        <div className="space-y-3" data-id="element-86">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-brand-card border border-white/10 rounded-xl overflow-hidden" data-id="element-87">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-88">
                <span className="font-bold text-brand-cream text-sm sm:text-base" data-id="element-89">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-orange transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-90" />
              </button>

              <AnimatePresence data-id="element-91">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-92">
                    <div className="px-5 pb-4 pt-0 text-sm text-gray-400 font-medium leading-relaxed" data-id="element-93">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}